// import React, { useState, useEffect } from "react";
// import { FaUserFriends } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const RegisterStep4 = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     maritalStatus: "",
//     heightFeet: "",
//     heightInches: "",
//     familyStatus: "",
//     familyType: "",
//     familyValues: "",
//     any_disability: "",
//   });

//   const maritalStatusOptions = ["Never Married", "Widowed", "Divorced", "Awaiting divorce"];
//   const familyStatusOptions = ["Middle class", "Upper middle class", "High class", "Rich/Affluent"];
//   const familyTypeOptions = ["Joint", "Nuclear"];
//   const familyValuesOptions = ["Orthodox", "Traditional", "Moderate", "Liberal"];
//   const disabilityOptions = ["None", "Physically challenged"];

//   useEffect(() => {
//     const savedData = JSON.parse(localStorage.getItem("registrationData"));
//     if (savedData) {
//       setFormData(prev => ({
//         ...prev,
//         maritalStatus: savedData.maritalStatus || "",
//         heightFeet: savedData.heightFeet || "",
//         heightInches: savedData.heightInches || "",
//         familyStatus: savedData.familyStatus || "",
//         familyType: savedData.familyType || "",
//         familyValues: savedData.familyValues || "",
//         any_disability: savedData.any_disability || "",
//       }));
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     const mergedData = { ...existingData, ...formData };
//     localStorage.setItem("registrationData", JSON.stringify(mergedData));
//     navigate("/register-step5");
//   };

//   const handleBack = () => {
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     const mergedData = { ...existingData, ...formData };
//     localStorage.setItem("registrationData", JSON.stringify(mergedData));
//     navigate("/register-step3");
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
//       <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">

//         {/* Left Info */}
//         <div className="md:w-1/1 bg-green-50 flex flex-col justify-center items-center p-8">
//           <FaUserFriends className="text-green-600 text-7xl mb-6" />
//           <p className="text-xl md:text-2xl font-semibold text-green-700 text-center">
//             Personal details get you the right matches
//           </p>
//         </div>

//         {/* Right Form */}
//         <div className="md:w-1/1 w-full bg-white p-8 rounded-lg shadow">
//           <h2 className="text-2xl font-semibold mb-2 text-gray-800">
//             Complete Your Personal Details
//           </h2>
//           <p className="text-sm text-gray-500 mb-4">
//             Fill in the details below to improve your match suggestions
//           </p>

//           <form onSubmit={handleSubmit} className="space-y-4">

//             {/* Marital Status */}
//             <div>
//               <label className="block text-gray-600 mb-1">Marital Status</label>
//               <div className="flex flex-wrap gap-2">
//                 {maritalStatusOptions.map(status => (
//                   <label
//                     key={status}
//                     className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer"
//                   >
//                     <input
//                       type="radio"
//                       name="maritalStatus"
//                       value={status}
//                       checked={formData.maritalStatus === status}
//                       onChange={handleChange}
//                       required
//                     />
//                     <span>{status}</span>
//                   </label>
//                 ))}
//               </div>
//             </div>

//             {/* Height */}
//             <div>
//               <label className="block text-gray-600 mb-1">Height</label>
//               <div className="grid grid-cols-2 gap-2">
//                 <select
//                   name="heightFeet"
//                   value={formData.heightFeet}
//                   onChange={handleChange}
//                   className="border p-2 rounded"
//                   required
//                 >
//                   <option value="">Feet</option>
//                   {[...Array(8)].map((_, i) => (
//                     <option key={i} value={i + 3}>
//                       {i + 3} ft
//                     </option>
//                   ))}
//                 </select>
//                 <select
//                   name="heightInches"
//                   value={formData.heightInches}
//                   onChange={handleChange}
//                   className="border p-2 rounded"
//                   required
//                 >
//                   <option value="">Inches</option>
//                   {[...Array(12)].map((_, i) => (
//                     <option key={i} value={i}>
//                       {i} in
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Family Status */}
//             <div>
//               <label className="block text-gray-600 mb-1">Family Status</label>
//               <div className="flex flex-wrap gap-2">
//                 {familyStatusOptions.map(status => (
//                   <label
//                     key={status}
//                     className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer"
//                   >
//                     <input
//                       type="radio"
//                       name="familyStatus"
//                       value={status}
//                       checked={formData.familyStatus === status}
//                       onChange={handleChange}
//                       required
//                     />
//                     <span>{status}</span>
//                   </label>
//                 ))}
//               </div>
//             </div>

//             {/* Family Type */}
//             <div>
//               <label className="block text-gray-600 mb-1">Family Type</label>
//               <div className="flex flex-wrap gap-2">
//                 {familyTypeOptions.map(type => (
//                   <label
//                     key={type}
//                     className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer"
//                   >
//                     <input
//                       type="radio"
//                       name="familyType"
//                       value={type}
//                       checked={formData.familyType === type}
//                       onChange={handleChange}
//                       required
//                     />
//                     <span>{type}</span>
//                   </label>
//                 ))}
//               </div>
//             </div>

//             {/* Family Values */}
//             <div>
//               <label className="block text-gray-600 mb-1">Family Values</label>
//               <div className="flex flex-wrap gap-2">
//                 {familyValuesOptions.map(value => (
//                   <label
//                     key={value}
//                     className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer"
//                   >
//                     <input
//                       type="radio"
//                       name="familyValues"
//                       value={value}
//                       checked={formData.familyValues === value}
//                       onChange={handleChange}
//                       required
//                     />
//                     <span>{value}</span>
//                   </label>
//                 ))}
//               </div>
//             </div>

//             {/* Disability */}
//             <div>
//               <label className="block text-gray-600 mb-1">Any Disability</label>
//               <select
//                 name="any_disability"
//                 value={formData.any_disability}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//                 required
//               >
//                 <option value="">Select</option>
//                 {disabilityOptions.map(d => (
//                   <option key={d} value={d}>{d}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Button Group */}
//             <div className="flex gap-3 mt-2">
//               <button
//                 type="button"
//                 onClick={handleBack}
//                 className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded transition duration-200"
//               >
//                 Back
//               </button>
//               <button
//                 type="submit"
//                 className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded transition duration-200"
//               >
//                 Continue
//               </button>
//             </div>
//           </form>

//           <p className="text-xs text-center text-gray-400 mt-4">
//             Copyright © 2025. All rights reserved.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RegisterStep4;

import React, { useState, useEffect } from "react";
import { FaUserFriends } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const RegisterStep4 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    maritalStatus: "",
    heightFeet: "",
    heightInches: "",
    familyStatus: "",
    familyType: "",
    familyValues: "",
    any_disability: "",
  });

  const [formErrors, setFormErrors] = useState({});

  const maritalStatusOptions = ["Never Married", "Widowed", "Divorced", "Awaiting divorce"];
  const familyStatusOptions = ["Middle class", "Upper middle class", "High class", "Rich/Affluent"];
  const familyTypeOptions = ["Joint", "Nuclear"];
  const familyValuesOptions = ["Orthodox", "Traditional", "Moderate", "Liberal"];
  const disabilityOptions = ["None", "Physically challenged"];

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("registrationData"));
    if (savedData) {
      setFormData(prev => ({
        ...prev,
        maritalStatus: savedData.maritalStatus || "",
        heightFeet: savedData.heightFeet || "",
        heightInches: savedData.heightInches || "",
        familyStatus: savedData.familyStatus || "",
        familyType: savedData.familyType || "",
        familyValues: savedData.familyValues || "",
        any_disability: savedData.any_disability || "",
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: "" })); // Clear error on change
  };

  const validateFields = () => {
    const errors = {};
    if (!formData.maritalStatus) errors.maritalStatus = "Marital status is required.";
    if (!formData.heightFeet) errors.heightFeet = "Height (feet) is required.";
    if (!formData.heightInches) errors.heightInches = "Height (inches) is required.";
    if (!formData.familyStatus) errors.familyStatus = "Family status is required.";
    if (!formData.familyType) errors.familyType = "Family type is required.";
    if (!formData.familyValues) errors.familyValues = "Family values are required.";
    if (!formData.any_disability) errors.any_disability = "This field is required.";
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateFields();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
    const mergedData = { ...existingData, ...formData };
    localStorage.setItem("registrationData", JSON.stringify(mergedData));
    navigate("/register-step5-html");
  };

  const handleBack = () => {
    const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
    const mergedData = { ...existingData, ...formData };
    localStorage.setItem("registrationData", JSON.stringify(mergedData));
    navigate("/register-step2-html");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">
        {/* Left Info */}
        <div className="md:w-1/1 bg-green-50 flex flex-col justify-center items-center p-8">
          <FaUserFriends className="text-green-600 text-7xl mb-6" />
          <p className="text-xl md:text-2xl font-semibold text-green-700 text-center">
            Personal details get you the right matches
          </p>
        </div>

        {/* Right Form */}
        <div className="md:w-1/1 w-full bg-white p-8 rounded-lg shadow">
          <h2 className="text-2xl font-semibold mb-2 text-gray-800">
            Complete Your Personal Details
          </h2>
          <p className="text-sm text-gray-500 mb-4">
            Fill in the details below to improve your match suggestions
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">

            {/* Marital Status */}
            <div>
              <label className="block text-gray-600 mb-1">Marital Status</label>
              <div className="flex flex-wrap gap-2">
                {maritalStatusOptions.map(status => (
                  <label key={status} className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer">
                    <input
                      type="radio"
                      name="maritalStatus"
                      value={status}
                      checked={formData.maritalStatus === status}
                      onChange={handleChange}
                    />
                    <span>{status}</span>
                  </label>
                ))}
              </div>
              {formErrors.maritalStatus && <p className="text-red-500 text-sm">{formErrors.maritalStatus}</p>}
            </div>

            {/* Height */}
            <div>
              <label className="block text-gray-600 mb-1">Height</label>
              <div className="grid grid-cols-2 gap-2">
                <select name="heightFeet" value={formData.heightFeet} onChange={handleChange} className="border p-2 rounded">
                  <option value="">Feet</option>
                  {[...Array(8)].map((_, i) => (
                    <option key={i} value={i + 3}>{i + 3} ft</option>
                  ))}
                </select>
                <select name="heightInches" value={formData.heightInches} onChange={handleChange} className="border p-2 rounded">
                  <option value="">Inches</option>
                  {[...Array(12)].map((_, i) => (
                    <option key={i} value={i}>{i} in</option>
                  ))}
                </select>
              </div>
              {formErrors.heightFeet && <p className="text-red-500 text-sm">{formErrors.heightFeet}</p>}
              {formErrors.heightInches && <p className="text-red-500 text-sm">{formErrors.heightInches}</p>}
            </div>

            {/* Family Status */}
            <div>
              <label className="block text-gray-600 mb-1">Family Status</label>
              <div className="flex flex-wrap gap-2">
                {familyStatusOptions.map(status => (
                  <label key={status} className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer">
                    <input
                      type="radio"
                      name="familyStatus"
                      value={status}
                      checked={formData.familyStatus === status}
                      onChange={handleChange}
                    />
                    <span>{status}</span>
                  </label>
                ))}
              </div>
              {formErrors.familyStatus && <p className="text-red-500 text-sm">{formErrors.familyStatus}</p>}
            </div>

            {/* Family Type */}
            <div>
              <label className="block text-gray-600 mb-1">Family Type</label>
              <div className="flex flex-wrap gap-2">
                {familyTypeOptions.map(type => (
                  <label key={type} className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer">
                    <input
                      type="radio"
                      name="familyType"
                      value={type}
                      checked={formData.familyType === type}
                      onChange={handleChange}
                    />
                    <span>{type}</span>
                  </label>
                ))}
              </div>
              {formErrors.familyType && <p className="text-red-500 text-sm">{formErrors.familyType}</p>}
            </div>

            {/* Family Values */}
            <div>
              <label className="block text-gray-600 mb-1">Family Values</label>
              <div className="flex flex-wrap gap-2">
                {familyValuesOptions.map(value => (
                  <label key={value} className="flex items-center space-x-2 border rounded px-3 py-1 cursor-pointer">
                    <input
                      type="radio"
                      name="familyValues"
                      value={value}
                      checked={formData.familyValues === value}
                      onChange={handleChange}
                    />
                    <span>{value}</span>
                  </label>
                ))}
              </div>
              {formErrors.familyValues && <p className="text-red-500 text-sm">{formErrors.familyValues}</p>}
            </div>

            {/* Disability */}
            <div>
              <label className="block text-gray-600 mb-1">Any Disability</label>
              <select
                name="any_disability"
                value={formData.any_disability}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              >
                <option value="">Select</option>
                {disabilityOptions.map(d => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
              {formErrors.any_disability && <p className="text-red-500 text-sm">{formErrors.any_disability}</p>}
            </div>

            {/* Buttons */}
            <div className="flex gap-3 mt-2">
              <button
                type="button"
                onClick={handleBack}
                className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded"
              >
                Back
              </button>
              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded"
              >
                Continue
              </button>
            </div>
          </form>

          <p className="text-xs text-center text-gray-400 mt-4">
            Copyright © 2025. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterStep4;

